import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import Chart from "react-apexcharts";

function BalanceDetail({ walletData, dashboardData, loading }) {
    const [options, setOptions] = useState({
        chart: {
            height: 250,
            type: 'donut',
        },
        dataLabels: {
            enabled: false,
        },
        legend: {
            position: 'top',
            horizontalAlign: 'center',
            show: true,
        },
        colors: ['var(--chart-color1)', 'var(--chart-color2)', 'var(--chart-color3)', 'var(--chart-color4)'],
        responsive: [{
            breakpoint: 480,
            options: {
                chart: {
                    width: 200
                },
                legend: {
                    position: 'bottom'
                }
            }
        }]
    });
    const [series, setSeries] = useState([44, 55, 41, 17]);

    useEffect(() => {
        // Update chart series based on wallet data from dashboard API
        const wallet = dashboardData?.data?.wallet || walletData?.balance || walletData;
        if (wallet) {
            const balance = parseFloat(wallet.balance || 0);
            // Only show chart if balance is greater than 0
            if (balance > 0 && !isNaN(balance)) {
                setSeries([balance, balance * 0.7, balance * 0.5, balance * 0.3]);
            } else {
                // Hide chart if no balance
                setSeries([]);
            }
        }
    }, [walletData, dashboardData]);

    const [options1, setOptions1] = useState({
        chart: {
            height: 250,
            type: 'donut',
        },
        dataLabels: {
            enabled: false,
        },
        legend: {
            position: 'top',
            horizontalAlign: 'center',
            show: true,
        },
        colors: ['var(--chart-color1)', 'var(--chart-color2)', 'var(--chart-color3)', 'var(--chart-color4)'],
        responsive: [{
            breakpoint: 480,
            options: {
                chart: {
                    width: 200
                },
                legend: {
                    position: 'bottom'
                }
            }
        }]
    });
    const [series1, setSeries1] = useState([44, 55, 41]);
    const [circlemultile, setCirclemultile] = useState({
        chart: {
            height: 250,
            type: 'radialBar',
        },
        colors: ['var(--chart-color1)', 'var(--chart-color2)', 'var(--chart-color3)', 'var(--chart-color4)'],
        plotOptions: {
            radialBar: {
                dataLabels: {
                    name: {
                        fontSize: '22px',
                    },
                    value: {
                        fontSize: '16px',
                    },
                    total: {
                        show: true,
                        label: 'Total',
                        formatter: function (w) {
                            // By default this function returns the average of all series. The below is just an example to show the use of custom formatter function
                            return 249
                        }
                    }
                }
            }
        },
        labels: ['Apples', 'Oranges', 'Bananas', 'Berries'],
    });
    const [seriescirclemultile, setSeriescirclemultile] = useState([44, 55, 67]);
    const [circleGradient, setCircleGradient] = useState({
        chart: {
            height: 250,
            type: 'radialBar',
            toolbar: {
                show: true
            }
        },
        colors: ['var(--chart-color1)'],
        plotOptions: {
            radialBar: {
                startAngle: -135,
                endAngle: 225,
                hollow: {
                    margin: 0,
                    size: '70%',
                    background: '#fff',
                    image: undefined,
                    imageOffsetX: 0,
                    imageOffsetY: 0,
                    position: 'front',

                    dropShadow: {
                        enabled: true,
                        top: 3,
                        left: 0,
                        blur: 4,
                        opacity: 0.24
                    }
                },
                track: {
                    background: '#fff',
                    strokeWidth: '67%',
                    margin: 0, // margin is in pixels
                    dropShadow: {
                        enabled: true,
                        top: -3,
                        left: 0,
                        blur: 4,
                        opacity: 0.35
                    }
                },

                dataLabels: {
                    showOn: 'always',
                    name: {
                        offsetY: -10,
                        show: true,
                        color: '#888',
                        fontSize: '17px'
                    },
                    value: {
                        formatter: function (val) {
                            return parseInt(val);
                        },
                        color: '#111',
                        fontSize: '36px',
                        show: true,
                    }
                }
            }
        },
        fill: {
            type: 'gradient',
            gradient: {
                shade: 'dark',
                type: 'horizontal',
                shadeIntensity: 0.5,
                gradientToColors: ['#ffd55d'],
                inverseColors: true,
                opacityFrom: 1,
                opacityTo: 1,
                stops: [0, 100]
            }
        },

        stroke: {
            lineCap: 'round'
        },
        labels: ['Percent'],
    });
    const [seriesCircleGradient, setSeriesCircleGradient] = useState([75]);
    const [circleChart, setCircleChart] = useState({
        chart: {
            height: 250,
            type: 'radialBar',
        },
        colors: ['var(--chart-color1)'],
        plotOptions: {
            radialBar: {
                hollow: {
                    size: '70%',
                }
            },
        },
        series: [70],
        labels: ['Cricket'],
    });
    const[seriesCircleChart,setSeriesCircleChart]=useState([70])

    if (loading) {
        return (
            <div className='row g-3 mb-3 row-deck'>
                <div className="col-xl-12 col-xxl-7">
                    <div className="card">
                        <div className="card-body">
                            <div className="text-center py-4">
                                <div className="spinner-border text-primary" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className='row g-3 mb-3 row-deck'>
            <div className="col-xl-12 col-xxl-7">
                <div className="card">
                    <div className="card-header py-3 d-flex justify-content-between bg-transparent border-bottom align-items-center">
                            <h6 className="mb-0 fw-bold">Balance Details</h6>
                        </div>
                        <div className="card-body">
                                    <div className="row g-3">
                                        <div className="col-lg-6">
                                            <div>Account balance:</div>
                                <h3>
                                    {(() => {
                                        const balance = dashboardData?.data?.wallet?.balance ?? walletData?.balance ?? 0;
                                        const numBalance = parseFloat(balance);
                                        return isNaN(numBalance) ? '0.00' : `${numBalance.toFixed(2)}`;
                                    })()}
                                </h3>
                                <div className="mt-3 pt-3 text-uppercase text-muted pt-2 small">Min Deposit:</div>
                                <h5>
                                    {(dashboardData?.data?.wallet?.minDeposit !== undefined || walletData?.minDeposit !== undefined)
                                        ? `${parseFloat(dashboardData?.data?.wallet?.minDeposit || walletData?.minDeposit || 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
                                        : '100.00'}
                                </h5>
                                <div className="mt-3 text-uppercase text-muted small">Max Deposit:</div>
                                <h5>
                                    {(dashboardData?.data?.wallet?.maxDeposit !== undefined || walletData?.maxDeposit !== undefined)
                                        ? `${parseFloat(dashboardData?.data?.wallet?.maxDeposit || walletData?.maxDeposit || 100000).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
                                        : '100,000.00'}
                                </h5>
                                <div className="mt-3 text-uppercase text-muted small">Deposits:</div>
                                <h5>
                                    {(dashboardData?.data?.wallet?.depositsEnabled !== undefined || walletData?.depositsEnabled !== undefined)
                                        ? (dashboardData?.data?.wallet?.depositsEnabled || walletData?.depositsEnabled) ? 'Enabled' : 'Disabled'
                                        : 'Enabled'}
                                </h5>
                                    </div>
                                        <div className="col-lg-6">
                                <div className="mt-3 pt-3 text-uppercase text-muted pt-2 small">Min Withdrawal:</div>
                                <h5>
                                    {(dashboardData?.data?.wallet?.minWithdrawal !== undefined || walletData?.minWithdrawal !== undefined)
                                        ? `${parseFloat(dashboardData?.data?.wallet?.minWithdrawal || walletData?.minWithdrawal || 50).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
                                        : '50.00'}
                                </h5>
                                <div className="mt-3 text-uppercase text-muted small">Max Withdrawal:</div>
                                <h5>
                                    {(dashboardData?.data?.wallet?.maxWithdrawal !== undefined || walletData?.maxWithdrawal !== undefined)
                                        ? `${parseFloat(dashboardData?.data?.wallet?.maxWithdrawal || walletData?.maxWithdrawal || 10000).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
                                        : '10,000.00'}
                                </h5>
                                        </div>
                                    </div>
                        </div>
                </div>
            </div>
            <div className="col-xl-12 col-xxl-5">
                <div className="card">
                    <div className="card-header py-3 d-flex justify-content-between bg-transparent align-items-center">
                        <h6 className="mb-0 fw-bold">Increase your account security</h6>
                    </div>
                    <div className="card-body">
                        <div className="row row-cols-2 g-0">
                            {/* Email Verification - from API */}
                            <div className="col">
                                <div className="security border-bottom border-end">
                                    <div className="d-flex align-items-start px-2 py-3">
                                        <div className={`mx-2 my-2 ${dashboardData?.data?.notifications?.emailVerified ? 'dot-green' : 'dot-red'}`}></div>
                                        <div className="d-flex flex-column">
                                            <span className="flex-fill text-truncate">Email Verification</span>
                                            <span>{dashboardData?.data?.notifications?.emailVerified ? 'Verified' : 'Not Verified'}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* Mobile Verification - from API */}
                            <div className="col">
                                <div className="security border-bottom">
                                    <div className="d-flex align-items-start px-2 py-3">
                                        <div className={`mx-2 my-2 ${dashboardData?.data?.notifications?.mobileVerified ? 'dot-green' : 'dot-red'}`}></div>
                                        <div className="d-flex flex-column">
                                            <span className="flex-fill text-truncate">Mobile Verification</span>
                                            <span>{dashboardData?.data?.notifications?.mobileVerified ? 'Verified' : 'Not Verified'}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* KYC Status - from API */}
                            <div className="col">
                                <div className="security border-bottom border-end">
                                    <div className="d-flex align-items-start px-2 py-3">
                                        <div className={`mx-2 my-2 ${dashboardData?.data?.notifications?.kycStatus === 'verified' || dashboardData?.data?.notifications?.kycStatus === 'approved' ? 'dot-green' : dashboardData?.data?.notifications?.kycStatus === 'pending' ? 'dot-yellow' : 'dot-red'}`}></div>
                                        <div className="d-flex flex-column">
                                            <span className="flex-fill text-truncate">Identity Verification (KYC)</span>
                                            <span className="text-capitalize">{dashboardData?.data?.notifications?.kycStatus || 'Pending'}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* Phone Number - from API */}
                            <div className="col">
                                <div className="security border-bottom">
                                    <div className="d-flex align-items-start px-2 py-3">
                                        <div className={`mx-2 my-2 ${dashboardData?.data?.notifications?.mobileVerified ? 'dot-green' : 'dot-red'}`}></div>
                                        <div className="d-flex flex-column">
                                            <span className="flex-fill text-truncate">Phone Number</span>
                                            <span>
                                                {dashboardData?.data?.account?.mobileNumber 
                                                    ? `${dashboardData.data.account.mobileNumber.slice(0, 2)}****${dashboardData.data.account.mobileNumber.slice(-2)}`
                                                    : 'N/A'}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* Email Address - from API */}
                            <div className="col">
                                <div className="security border-end">
                                    <div className="d-flex align-items-start px-2 py-3">
                                        <div className={`mx-2 my-2 ${dashboardData?.data?.notifications?.emailVerified ? 'dot-green' : 'dot-red'}`}></div>
                                        <div className="d-flex flex-column">
                                            <span className="flex-fill text-truncate">Email Address</span>
                                            <span>
                                                {dashboardData?.data?.account?.email 
                                                    ? (() => {
                                                        const email = dashboardData.data.account.email;
                                                        const [local, domain] = email.split('@');
                                                        return `${local.slice(0, 2)}***@${domain}`;
                                                    })()
                                                    : 'N/A'}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => ({
    walletData: state.data?.wallet,
    dashboardData: state.data?.dashboard,
    loading: state.data?.loading?.wallet || state.data?.loading?.dashboard || false,
});

export default connect(mapStateToProps)(BalanceDetail);